'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBootstrap = require('react-bootstrap');

var _pagination = require('@react-bootstrap/pagination');

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DataTable = function (_React$Component) {
	_inherits(DataTable, _React$Component);

	/* istanbul ignore next */
	function DataTable(props) {
		_classCallCheck(this, DataTable);

		var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));

		_this.state = {
			expandedRows: {},
			selectedRows: []
		};
		_this.onExpandCollapseRow = _this.onExpandCollapseRow.bind(_this);
		_this.onExpandCollapseAllRows = _this.onExpandCollapseAllRows.bind(_this);
		_this.onChangeHeaderCheckbox = _this.onChangeHeaderCheckbox.bind(_this);
		_this.onChangeBodyCheckbox = _this.onChangeBodyCheckbox.bind(_this);
		_this.onChangeSelection = _this.onChangeSelection.bind(_this);
		return _this;
	}

	_createClass(DataTable, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			var _props = this.props,
			    expandedRowRender = _props.expandedRowRender,
			    expandedRows = _props.expandedRows,
			    preSelectedRows = _props.preSelectedRows,
			    preSelectAll = _props.preSelectAll,
			    items = _props.items;

			if (expandedRowRender && expandedRows) {
				// check if expandedRows is a boolean (=== true is intentional)
				if (expandedRows === true) {
					this.expandAllRows();
				} else {
					this.expandRows(expandedRows);
				}
			}

			if (preSelectAll) {
				this.setState({ selectedRows: Array.from(items.keys()) });
			} else if (preSelectAll === undefined && preSelectedRows !== undefined) {
				this.setState({ selectedRows: preSelectedRows });
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var changingRowCount = this.props.items.length !== nextProps.items.length;
			if (changingRowCount && !nextProps.preSelectedRows) {
				this.setState({ selectedRows: [] });
			} else if (nextProps.preSelectedRows) {
				this.setState({
					selectedRows: nextProps.preSelectedRows
				});
			}
		}

		// set selectedRows to all (de)selected and update UI accordingly

	}, {
		key: 'onChangeHeaderCheckbox',
		value: function onChangeHeaderCheckbox(checked) {
			var selectedRows = [];
			if (checked) {
				Array.from(this.props.items.keys(), function (i) {
					return selectedRows.push(i);
				});
			}

			this.onChangeSelection(selectedRows);
		}

		// add/remove (de)selected item from the selectedRows list

	}, {
		key: 'onChangeBodyCheckbox',
		value: function onChangeBodyCheckbox(i, checked) {
			var selectedRows = this.state.selectedRows.slice();
			var index = void 0;

			function sortedIndex(array, newElement) {
				var lessThan = array.filter(function (el) {
					return el < newElement;
				});
				return lessThan.length;
			}

			if (checked) {
				index = sortedIndex(selectedRows, i);
				selectedRows.splice(index, 0, i);
			} else {
				index = selectedRows.indexOf(i);
				selectedRows.splice(index, 1);
			}

			this.onChangeSelection(selectedRows);
		}

		// updates the state variable for selections and call the callback

	}, {
		key: 'onChangeSelection',
		value: function onChangeSelection(selectedRows) {
			if (this.props.onChangeSelection) {
				this.props.onChangeSelection(selectedRows);
			}

			this.setState({ selectedRows: selectedRows });
		}
	}, {
		key: 'onExpandCollapseAllRows',
		value: function onExpandCollapseAllRows(expanded) {
			if (expanded) {
				this.collapseAllRows();
			} else {
				this.expandAllRows();
			}
		}
	}, {
		key: 'onExpandCollapseRow',
		value: function onExpandCollapseRow(i, expanded) {
			if (expanded) {
				this.collapseRow(i);
			} else {
				this.expandRow(i);
			}
		}
	}, {
		key: 'expandAllRows',
		value: function expandAllRows() {
			var items = this.props.items;

			var expandedRows = {};
			if (!items) {
				return;
			}
			for (var i = 0; i < items.length; ++i) {
				expandedRows[i] = true;
			}
			this.setState({
				expandedRows: _extends({}, this.state.expandedRows, expandedRows)
			});
		}
	}, {
		key: 'expandRows',
		value: function expandRows(rows) {
			var expandedRows = {};
			for (var i = 0; i < rows.length; ++i) {
				expandedRows[rows[i]] = true;
			}
			this.setState({
				expandedRows: _extends({}, this.state.expandedRows, expandedRows)
			});
		}
	}, {
		key: 'expandRow',
		value: function expandRow(i) {
			this.setState({
				expandedRows: _extends({}, this.state.expandedRows, _defineProperty({}, i, true))
			});
		}
	}, {
		key: 'collapseRow',
		value: function collapseRow(i) {
			var expandedRows = this.state.expandedRows;
			delete expandedRows[i];
			this.setState(_extends({}, this.state, {
				expandedRows: expandedRows
			}));
		}
	}, {
		key: 'collapseAllRows',
		value: function collapseAllRows() {
			this.setState({
				expandedRows: {}
			});
		}
	}, {
		key: 'allRowsExpanded',
		value: function allRowsExpanded() {
			var items = this.props.items;

			return items && items.length === Object.keys(this.state.expandedRows).length;
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    columns = _props2.columns,
			    paging = _props2.paging,
			    loading = _props2.loading,
			    className = _props2.className,
			    clickable = _props2.clickable,
			    sortable = _props2.sortable,
			    expandedRowRender = _props2.expandedRowRender,
			    rowActions = _props2.rowActions,
			    headers = _props2.headers,
			    striped = _props2.striped,
			    count = _props2.count,
			    items = _props2.items,
			    offset = _props2.offset,
			    numItemsPerPage = _props2.numItemsPerPage,
			    perPageCounts = _props2.perPageCounts,
			    onHeaderClick = _props2.onHeaderClick,
			    hideMultiSelectableText = _props2.hideMultiSelectableText;
			var _props3 = this.props,
			    loadMore = _props3.loadMore,
			    onChangeItemsPerPage = _props3.onChangeItemsPerPage;


			var collapsable = !!expandedRowRender;
			var classNames = [];
			if (className) {
				classNames.push(className);
			}
			if (collapsable) {
				classNames.push('collapsable');
			}
			if (clickable) {
				classNames.push('clickable');
			}
			if (sortable) {
				classNames.push('sortable');
			}
			if (striped) {
				classNames.push('striped');
			}

			var pageNum = Math.floor(offset / numItemsPerPage) + 1; // 1-based
			var itemCount = count || items && items.length || 0;
			var numPages = Math.ceil(itemCount / numItemsPerPage);

			var selectedRows = this.state.selectedRows;
			var isAllRowsSelected = items.length === selectedRows.length && items.length !== 0;

			var rowsCheckedStatus = Array.from(items.keys(), function () {
				return false;
			});
			selectedRows.map(function (i) {
				return rowsCheckedStatus[i] = true;
			});

			return _react2.default.createElement(
				'table',
				{ className: 'table-view ' + classNames.join(' ') },
				headers && _react2.default.createElement(DataTable.Header, {
					columns: columns,
					collapsable: collapsable,
					sortable: sortable,
					expanded: this.allRowsExpanded(),
					rowActions: rowActions,
					onExpandCollapseAllRows: this.onExpandCollapseAllRows,
					onChangeHeaderCheckbox: this.onChangeHeaderCheckbox,
					checked: isAllRowsSelected,
					multiSelectable: this.props.multiSelectable,
					onHeaderClick: onHeaderClick,
					hideMultiSelectableText: hideMultiSelectableText
				}),
				_react2.default.createElement(TableBody, _extends({}, this.props, {
					expandedRows: this.state.expandedRows,
					rowActions: rowActions,
					onExpandCollapseRow: this.onExpandCollapseRow,
					rowsCheckedStatus: rowsCheckedStatus,
					onChangeBodyCheckbox: this.onChangeBodyCheckbox
				})),
				_react2.default.createElement(DataTable.Footer, {
					paging: paging,
					loading: loading,
					numPages: numPages,
					numColumns: columns ? columns.length : 0,
					loadMore: loadMore,
					numItemsPerPage: numItemsPerPage,
					onChangeItemsPerPage: onChangeItemsPerPage,
					perPageCounts: perPageCounts,
					page: pageNum,
					offset: offset,
					count: count,
					items: items
				})
			);
		}
	}]);

	return DataTable;
}(_react2.default.Component);

DataTable.propTypes = {
	className: _propTypes2.default.string,
	columns: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
	items: _propTypes2.default.arrayOf(_propTypes2.default.any).isRequired,
	paging: _propTypes2.default.bool,
	offset: _propTypes2.default.number,
	count: _propTypes2.default.number,
	loadMore: _propTypes2.default.func,
	onChangeItemsPerPage: _propTypes2.default.func,
	numItemsPerPage: _propTypes2.default.number,
	perPageCounts: _propTypes2.default.arrayOf(_propTypes2.default.number),
	loading: _propTypes2.default.bool,
	clickable: _propTypes2.default.bool,
	sortable: _propTypes2.default.bool,
	headers: _propTypes2.default.bool,
	striped: _propTypes2.default.bool,
	/* what will render when a row expands?
  * function parameter is the item of the currently rendering row
  */
	expandedRowRender: _propTypes2.default.func,
	expandedRows: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
	rowActions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
		name: _propTypes2.default.string,
		action: _propTypes2.default.func
	})), _propTypes2.default.func]),
	/** switch to enable/disable selection checkboxes */
	multiSelectable: _propTypes2.default.bool,
	/** array of rows' index to be rendered selected by default */
	preSelectedRows: _propTypes2.default.arrayOf(_propTypes2.default.number),
	/** switch to render all rows selected by default. It overrides 'preSelectedRows' behaviour */
	preSelectAll: _propTypes2.default.bool,
	/** callback. Returns an array of selected rows' index */
	onChangeSelection: _propTypes2.default.func,
	/** callback. this cb is fired when header is clicked with the column item */
	onHeaderClick: _propTypes2.default.func,
	/** hide the "all" text if this is true */
	hideMultiSelectableText: _propTypes2.default.bool,
	/** Override styles to be applied to additional columns if they are displayed */
	additionalColumnStyles: _propTypes2.default.shape({
		collapsable: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
		multiSelectable: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
		rowActions: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	})
};

DataTable.defaultProps = {
	className: '',
	headers: true,
	striped: true,
	offset: 0,
	hideMultiSelectableText: false,
	additionalColumnStyles: {},
	numItemsPerPage: 10
};

/**
 *
 */

var TableHeader = function (_React$Component2) {
	_inherits(TableHeader, _React$Component2);

	function TableHeader(props) {
		_classCallCheck(this, TableHeader);

		var _this2 = _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call(this, props));

		_axwayReactIntl2.default.init(_this2);
		_this2.onChangeHeaderCheckbox = _this2.onChangeHeaderCheckbox.bind(_this2);
		_this2.onExpandCollapseAllRows = _this2.onExpandCollapseAllRows.bind(_this2);
		return _this2;
	}

	_createClass(TableHeader, [{
		key: 'onChangeHeaderCheckbox',
		value: function onChangeHeaderCheckbox() {
			this.props.onChangeHeaderCheckbox(!this.props.checked);
		}
	}, {
		key: 'onExpandCollapseAllRows',
		value: function onExpandCollapseAllRows(e) {
			e.preventDefault();
			e.stopPropagation();
			var _props4 = this.props,
			    onExpandCollapseAllRows = _props4.onExpandCollapseAllRows,
			    expanded = _props4.expanded;

			if (onExpandCollapseAllRows) {
				onExpandCollapseAllRows(expanded);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props5 = this.props,
			    columns = _props5.columns,
			    collapsable = _props5.collapsable,
			    expanded = _props5.expanded,
			    rowActions = _props5.rowActions,
			    checked = _props5.checked,
			    multiSelectable = _props5.multiSelectable,
			    onHeaderClick = _props5.onHeaderClick;

			var columnList = [];
			if (!columns) {
				return null;
			}
			if (collapsable) {
				columnList.push(_react2.default.createElement(
					'th',
					{
						key: 'row-collapse',
						className: 'row-collapse',
						onClick: function onClick(e) {
							(0, _accessibilityUtils.OnActionMouse)(e, _this3.onExpandCollapseAllRows);
						},
						onKeyPress: function onKeyPress(e) {
							(0, _accessibilityUtils.OnActionKey)(e, _this3.onExpandCollapseAllRows);
						}
					},
					_react2.default.createElement('a', { className: 'gg icon-GG-chevron-' + (expanded ? 'down' : 'right') + '-circle' })
				));
			}

			if (multiSelectable) {
				columnList.push(_react2.default.createElement(
					'th',
					{ key: 'select-all', className: 'selection' },
					_react2.default.createElement(_reactBootstrap.Checkbox, {
						'aria-label': 'toggle all rows selected',
						checked: checked,
						onChange: this.onChangeHeaderCheckbox,
						onKeyPress: function onKeyPress(e) {
							e.stopPropagation();
							(0, _accessibilityUtils.OnActionKey)(e, _this3.onChangeHeaderCheckbox);
						},
						inline: true
					}),
					!this.props.hideMultiSelectableText ? this.intl.formatMsg('All') : null
				));
			}

			columnList.push(columns.map(function (column, i) {
				if (column.display === false) {
					return null;
				}
				var colSpan = column.colSpan || 1;
				colSpan += i === columns.length - 1 && rowActions ? 1 : 0;
				var className = column.className;
				if (typeof className === 'function') {
					className = column.className(null);
				}
				return _react2.default.createElement(
					'th',
					{
						key: i,
						colSpan: colSpan,
						className: className,
						onClick: function onClick(e) {
							if (column.sortable) {
								e.preventDefault();
								e.stopPropagation();
								(0, _accessibilityUtils.OnActionMouse)(e, function () {
									return onHeaderClick(column);
								});
							}
						},
						onKeyPress: function onKeyPress(e) {
							if (column.sortable) {
								e.preventDefault();
								e.stopPropagation();
								(0, _accessibilityUtils.OnActionKey)(e, function () {
									return onHeaderClick(column);
								});
							}
						}
					},
					column.name,
					column.sortable ? _react2.default.createElement('span', { className: 'gg icon-GG-sort-both sortHeads' }) : null
				);
			}));

			return _react2.default.createElement(
				'thead',
				null,
				_react2.default.createElement(
					'tr',
					null,
					columnList
				)
			);
		}
	}]);

	return TableHeader;
}(_react2.default.Component);

TableHeader.propTypes = {
	columns: _propTypes2.default.arrayOf(_propTypes2.default.object),
	/** switch to enable/disable selection checkboxes */
	multiSelectable: _propTypes2.default.bool,
	/** SelectAll checkbox' checked status to be rendered */
	checked: _propTypes2.default.bool,
	/** callback. Returns SelectAll checkbox' checked status (bool) each time it's (de)selected */
	onChangeHeaderCheckbox: _propTypes2.default.func,
	/** callback. this cb is fired when header is clicked with the column item */
	onHeaderClick: _propTypes2.default.func,
	/** hide the "all" text if this is true */
	hideMultiSelectableText: _propTypes2.default.bool,
	/** callback. this is fired when the expand/collapse button is selected */
	onExpandCollapseAllRows: _propTypes2.default.func,
	/** the header displays the state where all rows are expanded */
	expanded: _propTypes2.default.bool
};

TableHeader.defaultProps = {
	hideMultiSelectableText: false
};

/**
 *
 */

var TableFooter = function (_React$Component3) {
	_inherits(TableFooter, _React$Component3);

	/* istanbul ignore next */
	function TableFooter(props) {
		_classCallCheck(this, TableFooter);

		var _this4 = _possibleConstructorReturn(this, (TableFooter.__proto__ || Object.getPrototypeOf(TableFooter)).call(this, props));

		_axwayReactIntl2.default.init(_this4);
		return _this4;
	}

	_createClass(TableFooter, [{
		key: 'shouldComponentUpdate',
		value: function shouldComponentUpdate(nextProps) {
			return this.props.loading !== nextProps.loading;
		}
	}, {
		key: 'renderPerPageOptions',
		value: function renderPerPageOptions() {
			var _this5 = this;

			if (!this.props.perPageCounts || !this.props.perPageCounts.length) {
				return null;
			}
			var options = [];
			this.props.perPageCounts.forEach(function (a, i) {
				if (a !== -1) {
					options.push(_react2.default.createElement(
						'option',
						{ key: 'opt-' + i, value: a.toString() },
						_this5.props.intl.formatNumber(a)
					));
				} else {
					options.push(_react2.default.createElement(
						'option',
						{ key: 'opt-' + i, value: a.toString() },
						_this5.intl.formatMsg('Max')
					));
				}
			});
			return options;
		}
	}, {
		key: 'render',
		value: function render() {
			var _props6 = this.props,
			    paging = _props6.paging,
			    numPages = _props6.numPages,
			    numColumns = _props6.numColumns,
			    numItemsPerPage = _props6.numItemsPerPage,
			    loadMore = _props6.loadMore,
			    page = _props6.page,
			    loading = _props6.loading,
			    offset = _props6.offset,
			    count = _props6.count,
			    items = _props6.items,
			    onChangeItemsPerPage = _props6.onChangeItemsPerPage;


			var showing = void 0;
			if (items && items.length > 1) {
				showing = this.intl.formatMsg('Showing {index} to {to} of {count} {count, plural, one {item} other {items}}', {
					index: offset + 1,
					to: offset + items.length,
					count: count
				});
			} else if (items && items.length === 1 && page !== 1 && numPages === page) {
				showing = this.intl.formatMsg('Showing last of the {count} {count, plural, one {item} other {items}}', {
					count: count
				});
			} else {
				showing = this.intl.formatMsg('Showing {count} {count, plural, one {item} other {items}}', {
					count: count
				});
			}

			if (paging) {
				return _react2.default.createElement(
					'tfoot',
					null,
					_react2.default.createElement(
						'tr',
						null,
						_react2.default.createElement(
							'td',
							{ colSpan: numColumns },
							_react2.default.createElement(
								'div',
								{ className: 'paging' },
								_react2.default.createElement(
									'div',
									{ className: 'per-page-selector' },
									_react2.default.createElement(
										_reactBootstrap.FormGroup,
										{ controlId: 'form-items-per-page pull-right' },
										_react2.default.createElement(
											_reactBootstrap.ControlLabel,
											null,
											this.intl.formatMsg('Items per page')
										),
										_react2.default.createElement(
											_reactBootstrap.FormControl,
											{
												componentClass: 'select',
												value: numItemsPerPage,
												onChange: onChangeItemsPerPage
											},
											this.renderPerPageOptions()
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'page-selector' },
									_react2.default.createElement(_pagination.Pagination, {
										prev: true,
										next: true,
										first: true,
										last: true,
										ellipsis: true,
										boundaryLinks: true,
										disabled: numItemsPerPage === -1,
										items: numPages,
										maxButtons: 6,
										activePage: page,
										onSelect: loadMore
									})
								),
								_react2.default.createElement(
									'div',
									null,
									_react2.default.createElement(
										'div',
										{ className: (0, _classnames2.default)('loading', { isLoading: loading }) },
										this.intl.formatMsg('Loading...')
									),
									_react2.default.createElement(
										'div',
										{ className: (0, _classnames2.default)('page-info', { isLoading: loading }) },
										showing
									)
								)
							)
						)
					)
				);
			} else {
				return null;
			}
		}
	}]);

	return TableFooter;
}(_react2.default.Component);

TableFooter.propTypes = {
	paging: _propTypes2.default.bool,
	loading: _propTypes2.default.bool,
	numPages: _propTypes2.default.number,
	numColumns: _propTypes2.default.number,
	page: _propTypes2.default.number,
	loadMore: _propTypes2.default.func,
	onChangeItemsPerPage: _propTypes2.default.func,
	numItemsPerPage: _propTypes2.default.number,
	offset: _propTypes2.default.number,
	count: _propTypes2.default.number,
	perPageCounts: _propTypes2.default.arrayOf(_propTypes2.default.number),
	items: _propTypes2.default.arrayOf(_propTypes2.default.any).isRequired
};

TableFooter.defaultProps = {
	perPageCounts: [10, 20, 30, 40, 50, 80, 100, -1]
};

/**
 *
 */

var TableBody = function (_React$Component4) {
	_inherits(TableBody, _React$Component4);

	function TableBody() {
		_classCallCheck(this, TableBody);

		return _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).apply(this, arguments));
	}

	_createClass(TableBody, [{
		key: 'buildRows',
		value: function buildRows() {
			var _this7 = this;

			var _props7 = this.props,
			    items = _props7.items,
			    columns = _props7.columns,
			    additionalColumnStyles = _props7.additionalColumnStyles,
			    offset = _props7.offset,
			    rowClick = _props7.rowClick,
			    expandedRowRender = _props7.expandedRowRender,
			    expandedRows = _props7.expandedRows,
			    onExpandCollapseRow = _props7.onExpandCollapseRow,
			    rowActions = _props7.rowActions;


			var max = items.length;
			var elements = [];

			var _loop = function _loop(i) {
				var item = items[i];
				var expandedRowContent = expandedRowRender && expandedRowRender(item, i);
				var collapsable = !!expandedRowContent;
				var onClick = void 0;
				if (rowClick || collapsable) {
					onClick = function onClick(e) {
						// react doesn't handle event propagation well:
						// https://github.com/facebook/react/issues/1691
						// This affects things like dropdowns and popovers within
						// the table.
						// we'll check the target on the DOM ourselves and see if it
						// or it's parents have the class ".row-clickable" and
						// do not fire events if it is found.

						var containsClass = function containsClass(target, currentTarget) {
							// Stop when we reach the element where the event was attached
							if (!target || target === currentTarget) {
								return false;
							}
							if (target.classList.contains('row-clickable')) {
								return true;
							} else {
								return containsClass(target.parentElement, currentTarget);
							}
						};

						if (containsClass(e.target, e.currentTarget)) {
							e.stopPropagation();
							return;
						}

						// expand the row if we have an accordion table
						/* istanbul ignore else */
						if (collapsable) {
							onExpandCollapseRow(i, expandedRows[i] || false);
						}
						if (rowClick) {
							rowClick(e, item);
						}
					};
				}
				var onChangeBodyCheckbox = _this7.props.onChangeBodyCheckbox.bind(_this7, i);
				elements.push(_react2.default.createElement(TableRow, {
					key: i + offset,
					rowIndex: i + offset,
					item: item,
					columns: columns,
					rowClick: onClick,
					hasCollapsePadding: !!expandedRowRender,
					collapsable: collapsable,
					expanded: expandedRows[i],
					rowActions: rowActions,
					additionalColumnStyles: additionalColumnStyles,
					checked: _this7.props.rowsCheckedStatus[i]
					/* eslint-disable-next-line react/jsx-no-bind */
					, onChangeBodyCheckbox: onChangeBodyCheckbox,
					multiSelectable: _this7.props.multiSelectable
				}));
				if (collapsable) {
					// add extra column span for expand/collapse button
					// and an optional one for the actions column
					var colSpan = columns.length + 1 + (rowActions ? 1 : 0);
					elements.push(_react2.default.createElement(TableRowCollapse, {
						key: i + offset + '_c',
						colSpan: colSpan,
						expanded: expandedRows[i],
						content: expandedRowContent
					}));
				}
			};

			for (var i = 0; i < max; ++i) {
				_loop(i);
			}
			return elements;
		}
	}, {
		key: 'render',
		value: function render() {
			var _props8 = this.props,
			    items = _props8.items,
			    columns = _props8.columns;


			var rows = void 0;
			if (items && columns && items.length && columns.length) {
				rows = this.buildRows();
			}
			return _react2.default.createElement(
				'tbody',
				null,
				rows
			);
		}
	}]);

	return TableBody;
}(_react2.default.Component);

TableBody.propTypes = {
	columns: _propTypes2.default.arrayOf(_propTypes2.default.object),
	items: _propTypes2.default.arrayOf(_propTypes2.default.any),
	offset: _propTypes2.default.number,
	count: _propTypes2.default.number,
	rowClick: _propTypes2.default.func,
	onExpandCollapseRow: _propTypes2.default.func,
	expandedRowRender: _propTypes2.default.func,
	expandedRows: _propTypes2.default.object,
	rowActions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
		name: _propTypes2.default.string,
		action: _propTypes2.default.func
	})), _propTypes2.default.func]),
	/** switch to enable/disable selection checkboxes */
	multiSelectable: _propTypes2.default.bool,
	/** An array of (un)checked state of all the rendered items */
	rowsCheckedStatus: _propTypes2.default.arrayOf(_propTypes2.default.bool),
	/** callback. Returns item index and checked status (bool) each time a row is (de)selected */
	onChangeBodyCheckbox: _propTypes2.default.func,
	/** Override styles to be applied to additional columns if they are displayed */
	additionalColumnStyles: _propTypes2.default.shape({
		collapsable: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
		multiSelectable: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
		actions: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	})
};

TableBody.defaultProps = {
	count: 0,
	expandedRows: {},
	onExpandCollapseRow: function onExpandCollapseRow() {},
	rowsCheckedStatus: [],
	onChangeBodyCheckbox: function onChangeBodyCheckbox() {},
	additionalColumnStyles: {}
};

/**
 *
 */

var TableRow = function (_React$Component5) {
	_inherits(TableRow, _React$Component5);

	function TableRow(props) {
		_classCallCheck(this, TableRow);

		var _this8 = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

		_this8.onChangeBodyCheckbox = _this8.onChangeBodyCheckbox.bind(_this8);
		return _this8;
	}

	_createClass(TableRow, [{
		key: 'onChangeBodyCheckbox',
		value: function onChangeBodyCheckbox() {
			var _props9 = this.props,
			    onChangeBodyCheckbox = _props9.onChangeBodyCheckbox,
			    checked = _props9.checked;

			if (onChangeBodyCheckbox) {
				onChangeBodyCheckbox(!checked);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var _props10 = this.props,
			    columns = _props10.columns,
			    item = _props10.item,
			    rowClick = _props10.rowClick,
			    collapsable = _props10.collapsable,
			    hasCollapsePadding = _props10.hasCollapsePadding,
			    expanded = _props10.expanded,
			    rowActions = _props10.rowActions,
			    checked = _props10.checked,
			    multiSelectable = _props10.multiSelectable,
			    rowIndex = _props10.rowIndex,
			    additionalColumnStyles = _props10.additionalColumnStyles;

			var cellsList = [];

			var getStyle = function getStyle(style) {
				if (typeof style === 'function') {
					return style(item, _this9);
				}
				return style;
			};

			if (item) {
				var i = void 0,
				    column = void 0;

				if (collapsable || hasCollapsePadding) {
					cellsList.push(_react2.default.createElement(
						'td',
						{
							className: 'row-collapse',
							key: 'icon',
							style: getStyle(additionalColumnStyles.collapsable)
						},
						collapsable && _react2.default.createElement('a', { className: 'gg icon-GG-chevron-' + (expanded ? 'down' : 'right') })
					));
				}
				if (multiSelectable) {
					cellsList.push(_react2.default.createElement(
						'td',
						{ key: 'checkbox', className: 'selection', style: getStyle(additionalColumnStyles.multiSelectable) },
						_react2.default.createElement(_reactBootstrap.Checkbox, {
							'aria-label': 'select single row',
							checked: checked,
							inline: true,
							onChange: this.onChangeBodyCheckbox,
							onKeyPress: function onKeyPress(e) {
								(0, _accessibilityUtils.OnActionKey)(e, _this9.onChangeBodyCheckbox);
							}
						})
					));
				}
				if (columns && columns.length) {
					for (i = 0; i < columns.length; ++i) {
						column = columns[i];
						cellsList.push(_react2.default.createElement(TableCell, { item: item, column: column, key: column.key || 'column_' + i }));
					}
				}

				if (rowActions) {
					var actions = [];
					// check if the rowActions is a function
					if (rowActions && rowActions.constructor && rowActions.call && rowActions.apply) {
						// if it's a function we can do item specific things
						actions = rowActions(item);
					} else {
						// otherwise just use a plain old list of names/actions
						actions = rowActions;
					}
					// only show menu if actions are defined
					if (actions && actions.length) {
						var items = actions.map(function (action, actionIndex) {
							return _react2.default.createElement(
								_reactBootstrap.MenuItem,
								{
									className: 'row-actions',
									key: 'action_' + rowIndex + '_' + actionIndex,
									eventKey: actionIndex + 1,
									onClick: function onClick(e) {
										e.stopPropagation();
										(0, _accessibilityUtils.OnActionMouse)(e, function () {
											e.preventDefault();
											e.stopPropagation();
											action.action(item);
										});
									},
									onKeyPress: function onKeyPress(e) {
										e.stopPropagation();
										(0, _accessibilityUtils.OnActionKey)(e, function () {
											e.preventDefault();
											e.stopPropagation();
											action.action(item);
										});
									}
								},
								action.name
							);
						});

						var actionTitle = _react2.default.createElement('a', { className: 'gg icon-GG-cog' });
						cellsList.push(_react2.default.createElement(
							'td',
							{ key: 'actions', className: 'row-actions', style: getStyle(additionalColumnStyles.rowActions) },
							_react2.default.createElement(
								_reactBootstrap.DropdownButton,
								{
									id: 'row-action-dropdown-' + rowIndex,
									className: 'row-clickable',
									pullRight: true,
									bsStyle: 'link',
									title: actionTitle
								},
								items
							)
						));
					} else {
						cellsList.push(_react2.default.createElement('td', { key: 'actions', className: 'row-actions', style: getStyle(additionalColumnStyles.rowActions) }));
					}
				}

				return _react2.default.createElement(
					'tr',
					{
						className: (0, _classnames2.default)(item.className, { 'cursor-pointer': rowClick }),
						style: getStyle(item.style),
						onClick: function onClick(e) {
							if (rowClick) {
								(0, _accessibilityUtils.OnActionMouse)(e, function () {
									e.preventDefault();
									rowClick(e, item);
								});
							}
						},
						onKeyPress: function onKeyPress(e) {
							if (rowClick) {
								(0, _accessibilityUtils.OnActionKey)(e, function () {
									e.preventDefault();
									rowClick(e, item);
								});
							}
						}
					},
					cellsList
				);
			} else {
				return null;
			}
		}
	}]);

	return TableRow;
}(_react2.default.Component);

TableRow.propTypes = {
	columns: _propTypes2.default.arrayOf(_propTypes2.default.object),
	item: _propTypes2.default.object,
	rowIndex: _propTypes2.default.number,
	rowClick: _propTypes2.default.func,
	collapsable: _propTypes2.default.bool,
	expanded: _propTypes2.default.bool,
	rowActions: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.shape({
		name: _propTypes2.default.string,
		action: _propTypes2.default.func,
		disabled: _propTypes2.default.bool
	})), _propTypes2.default.func]),
	/** padding needs to be added if the table
  * has some collapsable rows but this row isn't collapsable */
	hasCollapsePadding: _propTypes2.default.bool,
	/** switch to enable/disable selection checkboxes */
	multiSelectable: _propTypes2.default.bool,
	/** row's checked status to be rendered */
	checked: _propTypes2.default.bool,
	/** callback. Returns row's checked status (bool) each time a row is (de)selected */
	onChangeBodyCheckbox: _propTypes2.default.func,
	/** Override styles to be applied to additional columns if they are displayed */
	additionalColumnStyles: _propTypes2.default.shape({
		collapsable: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
		multiSelectable: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func]),
		rowActions: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func])
	})
};

TableRow.defaultProps = {
	additionalColumnStyles: {}
};

var TableRowCollapse = function (_React$Component6) {
	_inherits(TableRowCollapse, _React$Component6);

	function TableRowCollapse(props) {
		_classCallCheck(this, TableRowCollapse);

		var _this10 = _possibleConstructorReturn(this, (TableRowCollapse.__proto__ || Object.getPrototypeOf(TableRowCollapse)).call(this, props));

		_this10.state = { willRender: props.expanded };
		return _this10;
	}

	_createClass(TableRowCollapse, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(props) {
			// makes sure render is deferred until the row is expanded once
			if (!this.state.willRender && props.expanded) {
				this.setState({
					willRender: true
				});
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props11 = this.props,
			    colSpan = _props11.colSpan,
			    content = _props11.content,
			    expanded = _props11.expanded;

			if (!content) {
				return null;
			}

			return _react2.default.createElement(
				'tr',
				{ className: '' + (expanded ? 'collapse-expanded' : 'collapse-collapsed') },
				_react2.default.createElement(
					'td',
					{ colSpan: colSpan },
					this.state.willRender && content
				)
			);
		}
	}]);

	return TableRowCollapse;
}(_react2.default.Component);

TableRowCollapse.propTypes = {
	expanded: _propTypes2.default.bool,
	content: _propTypes2.default.node,
	colSpan: _propTypes2.default.number
};

TableRowCollapse.defaultProps = {
	expanded: false,
	colSpan: 1
};

/**
 *
 */

var TableCell = function (_React$Component7) {
	_inherits(TableCell, _React$Component7);

	function TableCell() {
		_classCallCheck(this, TableCell);

		return _possibleConstructorReturn(this, (TableCell.__proto__ || Object.getPrototypeOf(TableCell)).apply(this, arguments));
	}

	_createClass(TableCell, [{
		key: 'render',
		value: function render() {
			var _props12 = this.props,
			    item = _props12.item,
			    column = _props12.column;

			var value = void 0,
			    title = void 0,
			    style = void 0;

			// className can be string or function
			var cellClassName = void 0;
			if (column.hasOwnProperty('className')) {
				if (typeof column.className === 'function') {
					cellClassName = column.className(item);
				} else {
					cellClassName = column.className;
				}
			}

			// value can be formatted using function
			if (column.hasOwnProperty('key')) {
				value = item[column.key];
				if (column.hasOwnProperty('format') && typeof column.format === 'function') {
					value = column.format(item, this);
				}

				title = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object' ? value : undefined;
			}

			style = column.style;
			if (column.hasOwnProperty('style') && typeof column.style === 'function') {
				style = column.style(item, this);
			}

			if (value !== undefined || title !== undefined) {
				return _react2.default.createElement(
					'td',
					{ className: cellClassName, title: title, style: style },
					value
				);
			} else {
				// push empty cell if item does not have key
				return _react2.default.createElement('td', { className: cellClassName, style: style });
			}
		}
	}]);

	return TableCell;
}(_react2.default.Component);

TableCell.propTypes = {
	column: _propTypes2.default.object.isRequired,
	item: _propTypes2.default.object.isRequired
};

DataTable.Body = TableBody;
DataTable.Row = TableRow;
DataTable.RowCollapse = TableRowCollapse;
DataTable.Cell = TableCell;
DataTable.Header = (0, _reactIntl.injectIntl)(TableHeader);
DataTable.Footer = (0, _reactIntl.injectIntl)(TableFooter);

var _default = DataTable;
exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(DataTable, 'DataTable', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(TableHeader, 'TableHeader', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(TableFooter, 'TableFooter', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(TableBody, 'TableBody', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(TableRow, 'TableRow', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(TableRowCollapse, 'TableRowCollapse', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(TableCell, 'TableCell', 'src/components/DataTable.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/DataTable.jsx');
}();

;